module.exports = __webpack_public_path__ + "img/rog_xbox.97c4f4f5.jpg";